<span [ngClass]="{
'text-danger': taskPriority === 'wysoki',
'text-primary-color': taskPriority === 'normalny',
'text-dark': taskPriority === 'niski'}">
{{ taskPriority }}</span>
